module.exports = __webpack_public_path__ + "static/media/ItemDetailScreen.a43c54c6.png";